import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import BackButton from '../../components/global/BackButton';
// import ProBadge from '../../components/global/ProBadge';
// import HorseIcon from '../../components/global/HorseIcon';
// import CalendarToday from '../../components/seller/CalendarToday';
import Loader from '../../components/global/Loader';
import { getSellerUsers, unsubscribeSeller } from '../../libs/apis';
import userImg from '../../assets/images/user.png';

export default function ProUpgrade() {
  const { t } = useTranslation();
  const history = useHistory();
  const { user, role } = useSelector(state => state.auth);
  const initialState = {
    selectedSeller: -1,
    isOpen: false,
    isLoading: false,
    isError: false,
    sellers: [],
    search: '',
    downgraded: false,
    upgradeLoading: false,
    upgradeError: false,
    selectedReason: 'pro_downgrade_reason_1',
    otherReason: '',
  };
  const [state, setMyState] = useState(initialState);
  const setState = newState => {
    setMyState(prevState => ({ ...prevState, ...newState }));
  };
  const {
    isOpen,
    sellers,
    isLoading,
    isError,
    search,
    selectedSeller,
    downgraded,
    upgradeLoading,
    upgradeError,
    selectedReason,
    otherReason,
  } = state;

  const reasoning = [
    'pro_downgrade_reason_1',
    'pro_downgrade_reason_2',
    'pro_downgrade_reason_3',
    'pro_downgrade_reason_4',
    'pro_downgrade_reason_5',
  ];

  if (role === 'admin') {
    history.push('/admin');
  }
  if (role !== 'seller') {
    history.push('/login?redirect=/seller&u=seller');
  }
  if (!user) history.push('/login');

  const isSuperUser = user.super_user || false;

  if (!isSuperUser) {
    history.push('/seller');
  }

  useEffect(() => {
    const getSellerData = () => {
      setState({ isLoading: true, isError: false });
      const payload = {
        subscription: 1,
      };
      getSellerUsers(payload)
        .then(resp => {
          if (resp.data.response.length > 0) {
            setState({ sellers: resp.data.response });
          }
        })
        .catch(err => {
          console.log('err', err);
          setState({ isError: true });
        })
        .finally(() => setState({ isLoading: false }));
    };
    getSellerData();
  }, []);

  const filterSeller =
    search !== ''
      ? sellers.filter(seller => {
          let found = false;
          if (seller.name && seller.name.includes(search)) {
            found = true;
          }
          if (seller.username.includes(search)) {
            found = true;
          }
          if (seller.email.includes(search)) {
            found = true;
          }
          return found;
        })
      : sellers;

  const upgradeSeller =
    selectedSeller !== -1
      ? sellers.find(seller => seller.id === selectedSeller)
      : null;

  const downgrade = async sellerId => {
    setState({ upgradeLoading: true, upgradeError: false });
    let reason = selectedReason;
    if (selectedReason === 'other' && otherReason !== '') {
      reason = otherReason;
    }
    const payload = {
      user_id: sellerId,
      reason: reason,
    };
    await unsubscribeSeller(payload)
      .then(resp => {
        if (resp.status === 200) {
          setState({ downgraded: true });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch(err => {
        console.log('err', err);
        setState({ upgradeError: true });
      })
      .finally(() => {
        setState({ upgradeLoading: false });
      });
  };

  return (
    <div className="admin-container">
      <BackButton
        text={t('pro_downgrade_title')}
        classes="bg-light fs-5 text-dark"
      />

      <div className="main-container py-3 pb-5">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="content pb-5">
                <div className="search-box mb-3">
                  <div className="d-flex align-items-center bg-white border px-3 py-1 rounded-3">
                    <span className="fa fa-search me-1 text-muted"></span>
                    <input
                      type="search"
                      className="form-control w-100 border-0 shadow-none"
                      placeholder={t('pro_search_seller_text')}
                      value={search}
                      onChange={e => {
                        setState({ search: e.target.value });
                      }}
                    />
                  </div>
                </div>

                {isLoading && (
                  <div className="d-flex justify-content-center">
                    <Loader />
                  </div>
                )}
                {isError && (
                  <div className="alert alert-danger mb-3 text-center">
                    <p className="mb-0">{t('pro_general_error')}</p>
                  </div>
                )}
                {filterSeller.length > 0 && (
                  <div className="seller-list">
                    {filterSeller.map((seller, index) => {
                      const { photo, name, username, email, id } = seller;
                      return (
                        <div
                          className="seller-item py-3 border-bottom"
                          key={index}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="seller-avatar me-2">
                              <img
                                src={photo ? photo : userImg}
                                className="rounded-circle w-32 h-32"
                                alt=""
                              />
                            </div>
                            <div className="seller-info" style={{ flex: '1' }}>
                              <h6 className="fw-bold mb-0">
                                {name ? (
                                  name
                                ) : (
                                  <em className="fw-normal text-secondary">
                                    {username}
                                  </em>
                                )}
                              </h6>
                              <h6 className="mb-0 text-muted fs-12">{email}</h6>
                            </div>
                            <div className="btn-upgrade">
                              <button
                                className="btn btn-outline-danger btn-sm shadow-sm fs-12"
                                onClick={() =>
                                  setState({
                                    selectedSeller: id,
                                    isOpen: true,
                                  })
                                }
                              >
                                {t('pro_downgrade')}
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                <Modal
                  isOpen={isOpen}
                  onRequestClose={() => setState({ isOpen: false })}
                  contentLabel="Modal"
                  className="reveal small p-3"
                  ariaHideApp={false}
                >
                  <div className="pt-4">
                    {/* <h6 className="mb-3 text-center text-success fw-bold">
                      `Upgrade this` seller?
                    </h6> */}
                    {downgraded && (
                      <div className="alert alert-success p-2 mb-3 text-center">
                        <p className="mb-0">{t('pro_downgrade_success')}</p>
                      </div>
                    )}
                    {upgradeError && (
                      <div className="alert alert-danger p-2 mb-3 text-center">
                        <p className="mb-0">{t('pro_general_error')}</p>
                      </div>
                    )}
                    {upgradeSeller && (
                      <div>
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              upgradeSeller.photo
                                ? upgradeSeller.photo
                                : userImg
                            }
                            alt={
                              upgradeSeller.name
                                ? upgradeSeller.name
                                : upgradeSeller.username
                            }
                            className="w-32 h-32 me-2 rounded-circle"
                          />
                          <div className="seller-name">
                            <h6 className="fw-bold mb-0">
                              {upgradeSeller.name
                                ? upgradeSeller.name
                                : upgradeSeller.username}
                            </h6>
                            <h6 className="small mb-0 text-muted">
                              {upgradeSeller.email}
                            </h6>
                          </div>
                        </div>
                        <div className="seller-info py-3">
                          <table className="table mb-3 table-white table-borderless table-sm">
                            <tbody>
                              <tr>
                                <th className="w-25 text-nowrap text-muted fw-normal">
                                  {t('hl_business_id')}
                                </th>
                                <td>:</td>
                                <td className="w-100 fw-bold">
                                  {upgradeSeller.business_id
                                    ? upgradeSeller.business_id
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <th className="w-25 text-nowrap text-muted fw-normal">
                                  {t('hl_phone')}
                                </th>
                                <td>:</td>
                                <td className="w-100 fw-bold">
                                  {upgradeSeller.phone}
                                </td>
                              </tr>
                              <tr>
                                <th className="w-25 text-nowrap text-muted fw-normal">
                                  {t('hl_address')}
                                </th>
                                <td>:</td>
                                <td className="w-100 fw-bold">
                                  {upgradeSeller.address
                                    ? upgradeSeller.address
                                    : '-'}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    <div className="downgrade-reason mb-3">
                      <h6 className="fw-bold mb-3">
                        {t('pro_downgrade_reason')}
                      </h6>
                      <select
                        name="reason"
                        id="reason"
                        className="form-select"
                        onChange={e =>
                          setState({ selectedReason: e.target.value })
                        }
                      >
                        {reasoning.map(re => (
                          <option value={re}>{t(re)}</option>
                        ))}
                      </select>
                      {selectedReason === 'pro_downgrade_reason_5' && (
                        <div className="mt-3">
                          <textarea
                            name="reason_other"
                            id="reason_other"
                            rows="3"
                            className="form-control"
                            placeholder={t('pro_other_reason')}
                            value={otherReason}
                            onChange={e =>
                              setState({ otherReason: e.target.value })
                            }
                          ></textarea>
                        </div>
                      )}
                    </div>

                    <div className="btn-container d-flex align-items-center justify-content-between">
                      <button
                        onClick={() => setState({ isOpen: false })}
                        className="btn btn-sm btn-outline-secondary w-50 shadow-sm"
                      >
                        {t('cancel_button')}
                      </button>
                      {upgradeLoading ? (
                        <button
                          className="btn btn-sm btn-outline-danger btn-disabled w-50 ms-3"
                          disabled
                        >
                          <span className="fa fa-refresh fa-spin me-2 text-danger"></span>
                          {t('pro_downgrade')}
                        </button>
                      ) : (
                        <button
                          onClick={() => downgrade(upgradeSeller.id)}
                          className="btn btn-sm btn-danger w-50 shadow-sm ms-3"
                        >
                          {t('pro_downgrade')}
                        </button>
                      )}
                    </div>
                  </div>
                  <button
                    className="btn btn-close close-reveal"
                    onClick={() => setState({ isOpen: false })}
                  >
                    &times;
                  </button>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <MainMenu /> */}
    </div>
  );
}
